import { DecoratorNode, $applyNodeReplacement } from 'lexical';
import { markRaw } from 'vue';
import EditorAttachment from '../Components/EditorAttachment.vue';
import { attachment } from '../Themes/EditorClasses';

const legacyAttachmentClass = 'ql-attachment';

function normalizeUrl(url) {
    if (!url) return url;
    let result = url;
    while (result.includes('&amp;')) {
        result = result.replace(/&amp;/g, '&');
    }
    return result;
}

function convertAttachmentElement(domNode) {
    const url = domNode.getAttribute('href');
    if (!url) return null;
    return { node: $createAttachmentNode({ url, fileName: domNode.textContent || url }) };
}

export class AttachmentNode extends DecoratorNode {
    __url;
    __fileName;

    static getType() {
        return 'attachment';
    }

    static clone(node) {
        return new AttachmentNode(node.__url, node.__fileName, node.__key);
    }

    constructor(url, fileName, key) {
        super(key);
        this.__url = url;
        this.__fileName = fileName || url;
    }

    static importJSON(serializedNode) {
        const { url, fileName } = serializedNode;
        return $createAttachmentNode({ url, fileName });
    }

    exportJSON() {
        return {
            type: 'attachment',
            version: 1,
            url: this.__url,
            fileName: this.__fileName,
        };
    }

    static importDOM() {
        return {
            a: (domNode) => {
                // Only OUR/legacy attachment links; plain links fall through to LinkNode.
                if (domNode.classList.contains(attachment) || domNode.classList.contains(legacyAttachmentClass)) {
                    return { conversion: convertAttachmentElement, priority: 2 };
                }
                return null;
            },
        };
    }

    exportDOM() {
        const element = document.createElement('a');
        element.setAttribute('href', this.__url);
        element.setAttribute('download', '');
        element.setAttribute('class', attachment);
        // span.__name mirrors EditorAttachment.vue so underline styling matches editor + public render.
        const name = document.createElement('span');
        name.setAttribute('class', `${attachment}__name`);
        name.textContent = this.__fileName;
        element.appendChild(name);
        return { element };
    }

    isInline() {
        return true;
    }

    createDOM() {
        return document.createElement('span');
    }

    updateDOM() {
        return false;
    }

    decorate() {
        return {
            component: markRaw(EditorAttachment),
            props: {
                url: this.__url,
                fileName: this.__fileName,
            },
        };
    }
}

export function $createAttachmentNode({ url, fileName }) {
    return $applyNodeReplacement(new AttachmentNode(normalizeUrl(url), fileName));
}

export function $isAttachmentNode(node) {
    return node instanceof AttachmentNode;
}
